import { createFileRoute } from "@tanstack/react-router";

import { LabelsPage } from "src/pages/LabelsPage";

export const Route = createFileRoute("/_auth/_coach/labels/")({
  component: LabelsPage,
  ssr: true,
  staticData: {
    getBreadcrumb() {
      return {
        id: "labels",
        labelTranslationKey: "labelsPage.title",
        href: "/labels",
      };
    },
  },
});
